module.exports = __webpack_public_path__ + "img/Produktbeispiel_7.0df7fed2.jpg";